import { Address } from "viem";
import { useState } from "react";
import { StackProps } from "@chakra-ui/react";
import { LanguageView } from "./LanguageView";
import { ProfileView } from "./ProfileView";

export interface ProfileNavProps extends StackProps {
  address?: Address;
  onOpenReferralModal: () => void;
}

enum ProfileNavView {
  PROFILE = "PROFILE",
  LANGUAGE = "LANGUAGE",
}

export const ProfileNav = ({ onOpenReferralModal, ...props }: ProfileNavProps) => {
  const [view, setView] = useState(ProfileNavView.PROFILE);
  if (view === ProfileNavView.PROFILE) {
    return (
      <ProfileView
        onOpenReferralModal={onOpenReferralModal}
        onClickLanguage={() => setView(ProfileNavView.LANGUAGE)}
        {...props}
      />
    );
  }
  return <LanguageView onBack={() => setView(ProfileNavView.PROFILE)} />;
};
